module.exports = __webpack_public_path__ + "static/media/PCN-2024-8-20-01-LG58.2193676a.pdf";